module.exports = __webpack_public_path__ + "static/media/kim.dda3b0da.png";